<template lang="html">
  <div class="controls-open-infos" @click="switchInfo">
    <div class="icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="1.566" height="12.87" viewBox="0 0 1.566 12.87">
        <path d="M1.26-11.034H2.826V-12.87H1.26ZM1.26,0H2.826V-9.324H1.26Z" transform="translate(-1.26 12.87)"/>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data(){
    return{

    }
  },
  computed: {
    ...mapGetters(['infoOpened'])
  },
  methods:{
    switchInfo(){
      if(this.infoOpened){
        this.$store.dispatch('setInfoOpened',false);
      }
      else{
        this.$store.dispatch('setInfoOpened',true);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.controls-open-infos{
  position: absolute;
  z-index: 33;
  bottom: 50px;
  left:60px;
  z-index: 9999990;
  cursor: pointer;
  &.light{
    .icon{
      border: 1px solid white;
      svg{
        path{
          fill:white;
        }
      }
    }
  }
  .icon{
    width: 48px;
    height: 40px;
    border-radius: 20px;
    background: transparent;
    border: 1px solid #333;
    &.light{
      border: 1px solid #333;
    }
    svg{
      position: absolute;
      top: 0;
      left:0;
      right:0;
      bottom: 0;
      margin:auto;
      height: 13px;
      path{
          fill:#333;
      }
    }
  }
}
@media only screen and (max-width:700px)  {
  .controls-open-infos{
    bottom: 30px;
    left:30px;
  }
}
</style>
